import { createSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';
import { selectBlockState } from './block.selectors';
import { selectSystemState } from './system.selectors';

export const selectDailyStateOverviewComponent = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.DailyStateOverviewComponent
);

export const dailyEnergyStateBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectDailyStateOverviewComponent,
  (systemState, dailyStateOverviewComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = dailyStateOverviewComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.systemEnergyState;
  }
);

export const dailyEnergyStatusBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectDailyStateOverviewComponent,
  (systemState, dailyStateOverviewComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = dailyStateOverviewComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.energyRequestState;
  }
);

export const dailyEnergyStateBySystemUidAndDefaultInstance = (systemUid: string) => createSelector(
  selectDailyStateOverviewComponent,
  (dailyStateOverviewComponent) => {
    return Object.values(dailyStateOverviewComponent).find((block) => block[systemUid])?.[systemUid]?.systemEnergyState;
  }
);

export const dailyPowerStateBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectDailyStateOverviewComponent,
  (systemState, dailyStateOverviewComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = dailyStateOverviewComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.systemPowerState;
  }
);

export const dailyPowerStatusBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectDailyStateOverviewComponent,
  (systemState, dailyStateOverviewComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = dailyStateOverviewComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.powerRequestState;
  }
);